import { render, staticRenderFns } from "./tipspointsale-table-history.vue?vue&type=template&id=4a75ae26"
import script from "./tipspointsale-table-history.vue?vue&type=script&lang=js"
export * from "./tipspointsale-table-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports